// extracted by mini-css-extract-plugin
export default {"button":"AdminMobileTabbtnBox_button__uxLMq","selected":"AdminMobileTabbtnBox_selected__Vp18G"};